import * as React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';
import { fetchPackingListReclamation } from 'utils/fetchers';

const SavManquantPackingListContent = ({ onChange, action, reclamationId }) => {

    // Hook si le dossier fait partie d'une packingList
    const [packingList, setPackingList] = React.useState(null);

    // UseEffect si le dossier est sur une packing list
    React.useEffect(() => {

        const promise = fetchPackingListReclamation(reclamationId);
        promise.then(response => {
            setPackingList(response);
        });

    }, []);

    // UseEffect sur la mise à jour
    React.useEffect(() => {
        onChange(null);
    }, [onChange]);

    // UseEffect sur les actions détails
    React.useEffect(() => {

        if (packingList !== null && !packingList) {
            return null;
        }

        const getActionData = () => {

            let actionData =
            {
                code: action.code,
                details: []
            };

            // On ajoute automatiquement l'action car il n'y a pas de saisie utilisateur
            actionData.details.push({
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: "Ce dossier n'a pas été réceptionné en Plateforme. Il est donc réaffecté au magasin"
            });

            return actionData;
        }

        onChange(getActionData());

    }, [action.code, onChange]);

    return (
        <>
            {packingList === null &&

                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            }

            {packingList !== null && !packingList &&

                <DialogContent>
                    <Typography variant="h5" sx={{ color: 'red' }}>
                        Cette action n'est pas autorisée pour ce dossier après-vente
                    </Typography>
                </DialogContent>
            }

            {packingList !== null && packingList &&

                <DialogContent />
            }
        </>
    );
}

export default SavManquantPackingListContent;